export default __webpack_public_path__ + "static/media/segre28.dc2b17b9.jpg";